import './SectionHeader.less';

const SectionHeader = ({ tag: Tag = 'h3', className = '', children, ...props }) => {
    const classNames = `SectionHeader ${className}`;

    return (
        <Tag {...props} className={classNames}>
            {children}
        </Tag>
    );
};

export default SectionHeader;